import { render, staticRenderFns } from "./ProfileDiscussions.vue?vue&type=template&id=dbb883aa&scoped=true&"
import script from "./ProfileDiscussions.vue?vue&type=script&lang=js&"
export * from "./ProfileDiscussions.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDiscussions.vue?vue&type=style&index=0&id=dbb883aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb883aa",
  null
  
)

export default component.exports